import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from "./front/pages/dashboard/dashboard.component";
const routes: Routes = [
  {
    path: '',
    component: DashboardComponent
   // canActivate: [AuthGuard]
  },
  {
    path: "booking",
    loadChildren: () => import("./front/pages/pages.module").then(m => m.PagesModule)
  },
  { path: '', pathMatch: 'full', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
